/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_ProgressInputs */

const en_us2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When should I add weight?`)
};

const pt_br2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando devo subir a carga?`)
};

const es_419_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo debo subir el peso?`)
};

const pt_pt2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando devo aumentar a carga?`)
};

const fr_fr2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand augmenter la charge ?`)
};

const de_de2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann sollte ich das Gewicht erhöhen?`)
};

const it_it2_coach_suggest_progress = /** @type {(inputs: Coach_Suggest_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando devo aumentare il carico?`)
};

/**
* | output |
* | --- |
* | "When should I add weight?" |
*
* @param {Coach_Suggest_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_progress = /** @type {((inputs?: Coach_Suggest_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_progress(inputs)
	if (locale === "es-419") return es_419_coach_suggest_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_progress(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_progress(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_progress(inputs)
	return en_us2_coach_suggest_progress(inputs)
});
export { coach_suggest_progress as "coach.suggest_progress" }